(function() {
  'use strict';

  function initCollectionHoverShowcase() {
    const sections = document.querySelectorAll('[data-section-type="collection-hover-showcase"]');
    
    sections.forEach((section) => {
      if (section.dataset.initialized === 'true') {
        return;
      }

      section.dataset.initialized = 'true';
      const items = section.querySelectorAll('[data-collection-item]');

      items.forEach((item) => {
        const imagesData = item.dataset.images;
        if (!imagesData) {
          return;
        }

        const images = imagesData.split('|').filter(img => img.trim() !== '');
        
        if (images.length <= 1) {
          // Only one image, no need to cycle
          const photo = item.querySelector('.m-collection-hover-item__photo');
          if (photo) {
            photo.classList.add('active');
          }
          return;
        }

        // Multiple images - set up cycling
        const photos = item.querySelectorAll('.m-collection-hover-item__photo');
        let currentIndex = 0;
        let cycleInterval = null;
        const transitionDuration = parseFloat(
          getComputedStyle(section).getPropertyValue('--image-transition-duration')
        ) || 0.6;

        function showPhoto(index) {
          photos.forEach((photo, i) => {
            photo.classList.remove('active');
            if (i === index) {
              photo.classList.add('active');
            }
          });
        }

        function startCycling() {
          if (photos.length <= 1) return;
          
          // Show first image immediately
          showPhoto(0);
          currentIndex = 0;

          // Cycle through images
          cycleInterval = setInterval(() => {
            currentIndex = (currentIndex + 1) % photos.length;
            showPhoto(currentIndex);
          }, transitionDuration * 1000 * 1.5); // Change image every 1.5x transition duration
        }

        function stopCycling() {
          if (cycleInterval) {
            clearInterval(cycleInterval);
            cycleInterval = null;
          }
          // Show first image when not hovering
          showPhoto(0);
        }

        // Start cycling on hover
        item.addEventListener('mouseenter', startCycling);
        item.addEventListener('mouseleave', stopCycling);

        // Initialize first image
        if (photos.length > 0) {
          showPhoto(0);
        }
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionHoverShowcase);
  } else {
    initCollectionHoverShowcase();
  }

  // Re-initialize when Shopify theme editor loads new sections
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.detail.sectionId) {
        const section = document.querySelector(`[data-section-id="${event.detail.sectionId}"]`);
        if (section && section.dataset.sectionType === 'collection-hover-showcase') {
          section.dataset.initialized = 'false';
          initCollectionHoverShowcase();
        }
      }
    });
  }
})();

